import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logo.svg";
import instagram from "../../assets/instagram.svg";
import x from "../../assets/x.svg";
import facebook from "../../assets/facebook.svg";
import linkedin from "../../assets/linkedin.svg";
import location from "../../assets/location.svg";
import phone from "../../assets/phone.svg";
import email from "../../assets/email.svg";
import tiktok from "../../assets/tiktok.svg";
import snapchat from "../../assets/snapchat.svg";

import "./style.css";
import SocialService from "../../services/SocialService";

const Footer = () => {
	const [data, setData] = useState({
		facebook: "",
		instagram: "",
		twitter: "",
		you_tube: "",
		snapchat: "",
		whatsapp: "",
		email: "",
	});
	const { t } = useTranslation();
	const socialService = new SocialService();

	useEffect(() => {
		socialService.getList().then((res) => {
			if (res?.status === 200) {
				setData(res?.data?.data);
			}
		});
	}, []);

	return (
		<div className="footer">
			<div className="container">
				<div className="default-section row">
					<div className="col-lg-3 col-md-12 col-12 one">
						<img src={logo} alt="logo" className="logo" />
						<div className="d-flex gap-8">
							{!!data?.snapchat && (
								<a href={data?.snapchat} target="_blank" rel="noreferrer">
									<img src={snapchat} alt="snapchat" width={30} height={30} />
								</a>
							)}
							{!!data?.instagram && (
								<a href={data?.instagram} target="_blank" rel="noreferrer">
									<img src={instagram} alt="instagram" width={32} height={32} />
								</a>
							)}
							{!!data?.twitter && (
								<a href={data?.twitter} target="_blank" rel="noreferrer">
									<img src={x} alt="x" width={32} height={32} />
								</a>
							)}
							{!!data?.facebook && (
								<a href={data?.facebook} target="_blank" rel="noreferrer">
									<img src={facebook} alt="facebook" width={32} height={32} />
								</a>
							)}
							{!!data?.linked_in && (
								<a href={data?.linked_in} target="_blank" rel="noreferrer">
									<img src={linkedin} alt="linkedin" width={32} height={32} />
								</a>
							)}
							{!!data?.tiktok && (
								<a href={data?.tiktok} target="_blank" rel="noreferrer">
									<img src={tiktok} alt="tiktok" width={32} height={32} />
								</a>
							)}
						</div>
					</div>
					<div className="col-lg-3 col-md-4 links col-6">
						<Link to="/">{t("home")}</Link>
						<Link to="/projects">{t("Our Project")}</Link>
						<Link to="/media-center">{t("Media Center")}</Link>
						<Link to="/about-us">{t("about-us")}</Link>
						<Link to="/contact-us">{t("contact us")}</Link>
					</div>
					<div className="col-lg-3 col-md-4 links col-6">
						<Link to="/privacy-policy">{t("Privcy Policy")}</Link>
						<Link to="/terms-conditions">{t("term & conditions")}</Link>
					</div>
					<div className="col-lg-3 col-md-4 links col-12">
						{!!data?.location && (
							<div className="d-flex gap-8 align-items-center mb-4">
								<img src={location} alt="location" width={24} height={24} />
								<a
									href={data?.location}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{t("location")}
								</a>
							</div>
						)}
						{!!data?.phone && (
							<div className="d-flex gap-8 align-items-center mb-4">
								<img src={phone} alt="phone" width={24} height={24} />
								<a
									href={`tel:${data?.phone}`}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{data?.phone}
								</a>
							</div>
						)}
						{data?.call_us && (
							<div className="d-flex gap-8 align-items-center mb-4">
								<img src={phone} alt="phone" width={24} height={24} />
								<a
									href={`tel:${data?.call_us}`}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{data?.call_us}
								</a>
							</div>
						)}
						{!!data?.email && (
							<div className="d-flex gap-8 align-items-center">
								<img src={email} alt="email" width={24} height={24} />
								<a
									href={`mailto:${data?.email}`}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{data?.email}
								</a>
							</div>
						)}
					</div>
				</div>
				<div>
					<p className="text-center power mb-0">
						{t("Powered By")}:{" "}
						<a
							rel="noreferrer"
							href="https://www.cloudliftsolution.com/"
							target="_blank"
							style={{
								color: "#fff",
								textDecoration: "none",
								margin: "0 2px",
							}}>
							Cloud Lift Solutions
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};
export default Footer;
